import { useState } from "react";
import primaryComponents from "../../../primaryComponents";
import { useValidation } from "../CheckoutPharmacyIndication/useValidation";
import { useCreatePharmacyIntervention } from "../../../../hooks/api/mutations/useOrder";

export const CreatePharmacyIntervention = ({ closeModal = () => {} }) => {
  const [formData, setformData] = useState({
    name: "",
  });

  const { mutate: createIndication, isLoading } =
    useCreatePharmacyIntervention();
  const handleCreateIntervention = () => {
    createIndication(formData, {
      onSuccess: () => {
        closeModal();
      },
    });
  };

  const {
    handleSubmit,
    control,
    register,
    trigger,
    formState: { errors },
  } = useValidation({ ...formData });

  return (
    <div>
      <primaryComponents.InputFieldV2
        name="name"
        control={control}
        register={register}
        label={"Intervention Name"}
        placeholder="Enter intervention name"
        errorMessage={errors.name}
        onKeyUp={() => errors.name !== undefined && trigger("name")}
        onChange={({ target: { value } }) => {
          setformData((prev) => ({ ...prev, name: value }));
        }}
      />
      <primaryComponents.Button
        classNames={"mt-4 btn btn--primary w-100"}
        isLoading={isLoading}
        isDisabled={isLoading}
        loadingText={"Creating..."}
        onClick={handleSubmit(handleCreateIntervention)}
      >
        Create Intervention
      </primaryComponents.Button>
    </div>
  );
};
